module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av185-bfcc8d3603e6e34d978388728fab7211.jpg";